import styled, {css} from "styled-components";
import {SwedenResponsibleGamingButtonBaseBox} from "../../boxes/sweden.responsible-gaming-button-base.box";

export const SwedenSelfExclusionButtonBox = styled(SwedenResponsibleGamingButtonBaseBox)<{useIconsOnly: boolean, isShownInHeader:boolean}>`
  
  ${props => props.useIconsOnly 
            ? css`
                background-image: url("${props => props.theme.images.regulationSpecific.sweden.selfExclusionButtonSymbol.toString()}");
                height: 23px;
            `
            : css`
                background-image: url("${props => props.theme.images.regulationSpecific.sweden.selfExclusionButton.toString()}");
            `
  }
  
  ${props => props.isShownInHeader ? css`
        background-size: auto 2.5rem;
        width: 8.5rem;
        height: 2.5rem;
  `: null}
`